import { render, staticRenderFns } from "./commodityClassificationAnalysis.vue?vue&type=template&id=8276d7aa&scoped=true"
import script from "./commodityClassificationAnalysis.vue?vue&type=script&lang=js"
export * from "./commodityClassificationAnalysis.vue?vue&type=script&lang=js"
import style0 from "./commodityClassificationAnalysis.vue?vue&type=style&index=0&id=8276d7aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8276d7aa",
  null
  
)

export default component.exports